module.exports = __webpack_public_path__ + "static/media/5021.10e39993.jpg";